export default function(data) {
  const url = URL.createObjectURL(new Blob([data], { type: 'application/excel' }))
  const link = document.createElement('a')

  link.href = url
  link.download = 'X5_' + this.$moment().format('DD.MM.YYYY_HH:mm') + '.xlsx'
  link.click()
}